import toast from 'react-hot-toast';

import useProject from 'hooks/useProject';
import useTheme from 'hooks/useTheme';
import { copyClipboard } from 'utils/commonUtils';
import { androidstudio, github } from 'react-code-blocks';

const useCode = () => {
  const project = useProject();
  const { themeType } = useTheme();

  const handleCopyClick = () => {
    if (!project.data?.code) return;

    copyClipboard(project.data.code);

    toast.success('소스코드를 복사했어요');
  };

  return {
    code: project.data?.code,
    codeTheme: themeType === 'dark' ? androidstudio : github,
    onCopyClick: handleCopyClick,
  };
};

export default useCode;
